import store from '..'
import axios from 'axios'
import API from '@/common/api'

export default {
  namespaced: true,
  state: {
    gaData: null,
    enterance: null,
    overall: null,
    userAge: null,
    userGender: null,
    userInterest: null
  },
  mutations: {
    setGaData (state, data) {
      state[data.target] = data.source
    },
    overallFilter (state, data) {
      /** data:
       * arr: [],
       * filter: []
       */
      console.log(data)
    }
  },
  actions: {
    async getAnalytics ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-analytics',
          func: 'get-analytics',
          id: store.state.authentication.requestId,
          from: data.from,
          to: data.to,
          dimensions: data.dimensions,
          metrics: data.metrics,
          dimensionFilter: data.dimensionFilter,
          limit: 10000
        })
        return res.data.message
      } catch (ex) {
        // alert(ex)
        console.log(ex)
        return false
      }
    },
    async getOverallLog ({ state, commit }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-analytics',
          func: 'get-hotel-overall-log',
          id: store.state.authentication.requestId,
          from: data.from,
          to: data.to
        })
        // state.overall = res.data.message.Items
        return res.data.message.Items
      } catch (ex) {
        // alert(ex)
        console.log(ex)
        return false
      }
    }
  },
  getters: {
    gaData: (state) => state.gaData,
    enterance: (state) => state.enterance,
    overall: (state) => state.overall,
    userAge: (state) => state.userAge,
    userGender: (state) => state.userGender,
    userInterest: (state) => state.userInterest
  }
}
